module.exports = __webpack_public_path__ + "img/mobile_map_concepcionhospital.699ccc4d.svg";